import { UserDto, UsersApi } from '@fms-run/backend-api-lib';

import FMSApiClient from '../lib/api-client';

const usersApi = () => FMSApiClient.use(UsersApi);

/**
 * Get current authenticated user profile
 * @returns Promise with current user details
 */
export async function getCurrentUser(): Promise<UserDto> {
  try {
    const { data } = await usersApi().usersControllerGetCurrentUser();

    return data;
  } catch (error) {
    console.error('Error fetching current user:', error);
    throw error;
  }
}
